type T = () => void;

const f: T = () => window.localStorage.clear();

export default f;
